import { useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { LEGACY_CATEGORY_MAP } from "@/lib/families";

/* Legacy /category/<slug> URLs redirect to the matching product family page. */
export default function CategoryPage() {
    const { slug } = useParams();
    const navigate = useNavigate();
    const target = LEGACY_CATEGORY_MAP[slug];

    useEffect(() => {
        if (target) navigate(`/family/${target}`, { replace: true });
    }, [target, navigate]);

    if (target) {
        return (
            <div className="min-h-screen bg-paper flex items-center justify-center">
                <p className="font-mono text-sm text-mist">Taking you to the family page…</p>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-paper text-ink flex items-center justify-center" data-testid="category-not-found">
            <div className="text-center">
                <p className="font-display font-semibold text-2xl mb-3">Category not found</p>
                <Link to="/" className="font-mono text-xs uppercase tracking-[0.2em] text-copper">Back to site</Link>
            </div>
        </div>
    );
}
